import { OpportunitySchema } from '@features/opportunities/modules/core/models/schema-property-definition';
import { OpportunitySchemaUtil } from '@features/opportunities/modules/core/utils/opportunity-schema-util';
import { NonApplicantPartnerDetails } from './non-applicant-partner';

export namespace RelationshipStatus {
  export interface SchemaPropertyDefinition {
    applicantPartner: OpportunitySchema.StringPropertyDefinition;
    nonApplicantPartner: NonApplicantPartnerDetails.SchemaPropertyDefinition;
    single: OpportunitySchema.EmptyObjectPropertyDefinition;
  }

  export type SchemaContract =
    | {
        applicantPartner: string;
      }
    | {
        nonApplicantPartner: NonApplicantPartnerDetails.SchemaContract;
      }
    | {
        single: {};
      }
    | {}
    | null
    | undefined;

  export enum Status {
    ApplicantPartner = 'applicantPartner',
    NonApplicantPartner = 'nonApplicantPartner',
    Single = 'single'
  }

  export type Model =
    | {
        status: null;
      }
    | {
        status: Status.ApplicantPartner;
        applicantId: string;
      }
    | {
        status: Status.NonApplicantPartner;
        nonApplicantExpenses: NonApplicantPartnerDetails.Model | null;
      }
    | {
        status: Status.Single;
      };

  export function toModel(contract: SchemaContract): Model {
    if (!contract || Object.keys(contract).length === 0) {
      return {
        status: null
      };
    }

    if ('applicantPartner' in contract) {
      return {
        status: Status.ApplicantPartner,
        applicantId: `individuals/${contract.applicantPartner}`
      };
    }

    if ('nonApplicantPartner' in contract) {
      return {
        status: Status.NonApplicantPartner,
        nonApplicantExpenses: NonApplicantPartnerDetails.toModel(
          contract.nonApplicantPartner
        )
      };
    }

    return {
      status: Status.Single
    };
  }

  export function toSchemaContract(model: Model): SchemaContract {
    switch (model.status) {
      case Status.ApplicantPartner:
        return {
          applicantPartner: OpportunitySchemaUtil.idFromReference(
            model.applicantId
          )
        };
      case Status.NonApplicantPartner:
        return {
          nonApplicantPartner: NonApplicantPartnerDetails.toSchemaContract(
            model.nonApplicantExpenses
          )
        };
      case Status.Single:
        return {
          single: {}
        };
      default:
        return undefined;
    }
  }
}
